import { render } from "./reduction_winner.vue?vue&type=template&id=3a6946d0&scoped=true"
import script from "./reduction_winner.vue?vue&type=script&lang=js"
export * from "./reduction_winner.vue?vue&type=script&lang=js"

import "./reduction_winner.vue?vue&type=style&index=0&id=3a6946d0&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6946d0"],['__file',"vue/js/components/sale/reduction/inside/fields/reduction_winner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a6946d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a6946d0', __exports__)) {
    console.log('reload')
    api.reload('3a6946d0', __exports__)
  }
  
  module.hot.accept("./reduction_winner.vue?vue&type=template&id=3a6946d0&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a6946d0', render)
  })

}


export default __exports__